import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Building2, Save } from "lucide-react";
import { toast } from "sonner";

export default function OrgProfile() {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/organizations/me").then((r)=>setF(r.data.organization)).catch(()=>{});
  }, []);
  const set = (k, v) => setF((s)=>({ ...s, [k]: v }));
  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/org/profile", {
        name: f.name, responsible_name: f.responsible_name, responsible_role: f.responsible_role,
        phone: f.phone, address: f.address, postal_code: f.postal_code, city: f.city,
        website: f.website, members_count: Number(f.members_count || 0), description: f.description,
        email_domain: (f.email_domain || "").replace(/^@/, ""),
        auto_attach_by_domain: !!f.auto_attach_by_domain,
        helloasso_url: f.helloasso_url || "",
      });
      toast.success("Profil enregistré.");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur."); }
    finally { setSaving(false); }
  };
  if (!f) return <div className="text-slate-500">Chargement…</div>;
  return (
    <div data-testid="org-profile-page">
      <h1 className="font-heading text-2xl md:text-3xl font-bold flex items-center gap-2"><Building2 className="text-emerald-700" size={24}/> Mon organisme</h1>
      <div className="mt-5 bg-white border border-slate-200 rounded-2xl p-5 grid md:grid-cols-2 gap-3">
        <div><Label>Nom *</Label><Input value={f.name || ""} onChange={(e)=>set("name", e.target.value)} data-testid="org-profile-name"/></div>
        <div><Label>Nombre approx. de membres</Label><Input type="number" min="0" value={f.members_count || 0} onChange={(e)=>set("members_count", e.target.value)}/></div>
        <div><Label>Responsable</Label><Input value={f.responsible_name || ""} onChange={(e)=>set("responsible_name", e.target.value)}/></div>
        <div><Label>Fonction</Label><Input value={f.responsible_role || ""} onChange={(e)=>set("responsible_role", e.target.value)}/></div>
        <div><Label>Téléphone</Label><Input value={f.phone || ""} onChange={(e)=>set("phone", e.target.value)}/></div>
        <div><Label>Site internet</Label><Input value={f.website || ""} onChange={(e)=>set("website", e.target.value)}/></div>
        <div className="md:col-span-2"><Label>Adresse</Label><Input value={f.address || ""} onChange={(e)=>set("address", e.target.value)}/></div>
        <div><Label>Code postal</Label><Input value={f.postal_code || ""} onChange={(e)=>set("postal_code", e.target.value)}/></div>
        <div><Label>Ville</Label><Input value={f.city || ""} onChange={(e)=>set("city", e.target.value)}/></div>
        <div className="md:col-span-2 bg-emerald-50 border border-emerald-200 rounded-xl p-3">
          <Label>Domaine email de vos membres (auto-rattachement)</Label>
          <div className="flex gap-2 mt-1">
            <Input value={f.email_domain || ""} onChange={(e)=>set("email_domain", e.target.value)} placeholder="entreprise.fr" data-testid="org-profile-domain"/>
            <label className="flex items-center gap-1 text-xs whitespace-nowrap">
              <input type="checkbox" checked={!!f.auto_attach_by_domain} onChange={(e)=>set("auto_attach_by_domain", e.target.checked)}/> Activer
            </label>
          </div>
          <p className="text-[11px] text-emerald-800 mt-1">Si activé, les inscriptions avec cet email de domaine sont automatiquement rattachées à votre organisme.</p>
        </div>
        <div className="md:col-span-2"><Label>Description</Label><Textarea rows={3} value={f.description || ""} onChange={(e)=>set("description", e.target.value)}/></div>
        <div className="md:col-span-2"><Label>Page HelloAsso (adhésion / billetterie)</Label><Input value={f.helloasso_url || ""} onChange={(e)=>set("helloasso_url", e.target.value)} placeholder="https://www.helloasso.com/associations/votre-organisme" data-testid="org-profile-helloasso"/><p className="text-[11px] text-slate-500 mt-1">Un bouton « Adhérer / Billetterie » apparaîtra sur votre page de rattachement.</p></div>
      </div>
      <div className="mt-4 flex justify-end">
        <Button onClick={save} disabled={saving} className="btn-shine text-white" data-testid="org-profile-save"><Save size={14} className="mr-1"/> {saving ? "..." : "Enregistrer"}</Button>
      </div>
    </div>
  );
}
